import { render } from "./EditInvoiceProp.vue?vue&type=template&id=ab3126c0&scoped=true"
import script from "./EditInvoiceProp.vue?vue&type=script&lang=js"
export * from "./EditInvoiceProp.vue?vue&type=script&lang=js"

import "./EditInvoiceProp.vue?vue&type=style&index=0&id=ab3126c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3126c0"]])

export default __exports__